export class Login {
  constructor(
    public username: string | null,
    public password: string | null,
  ) { }
}